export default {
  'common': {
    'confirm': 'Confirmar',
    'add': 'Añadir',
    'cancel': 'Cancelar',
    'description': 'Descripción',
    'delete': 'Eliminar',
    'title': 'Título',
    'save': 'Salvar',
    'faq': 'Preguntas más frecuentes',
    'contact': 'Contáctenos',
    'tos': 'Términos de servicio',
    'policy': 'Política de privacidad',
    'updateAvailable': 'Hay una nueva versión disponible.',
    'reload': 'Actualizar'
  },
  'theme': {
    'os': 'Sistema',
    'light': 'Claro',
    'dark': 'Oscuro'
  },
  'board': {
    'titlePlaceholder': 'Ingresa un título para esta tarjeta',
    'deleteDescription': '¿Estás seguro de que deseas eliminar esta tarjeta?',
    'editCard': 'Editar tarjeta',
    'deleteCard': 'Eliminar tarjeta',
    'state': {
      'TODO': 'QUE HACER',
      'INPROGRESS': 'EN PROGRESO',
      'TESTING': 'PRUEBAS',
      'CHECK': 'REVISIÓN',
      'DONE': 'HECHO',
    }
  },
  'chat': {
    'online': 'Usuarios en línea ({count})',
    'addChannel': 'Agregar canal',
    'channel': 'Canal | Canales',
    'message': 'Mensaje'
  },
  'email': {
    'compose': 'Escribir correo',
    'send': 'Enviar',
    'subject': 'Tema',
    'labels': 'Etiquetas',
    'emptyList': 'Lista de correo electrónico vacía',
    'inbox': 'Bandeja de entrada',
    'sent': 'Expedido',
    'drafts': 'Borradores',
    'starred': 'Sembrado de estrellas',
    'trash': 'Basura',
    'work': 'Trabajo',
    'invoice': 'Factura'
  },
  'todo': {
    'addTask': 'Agregar tarea',
    'tasks': 'Tareas',
    'completed': 'Terminado',
    'labels': 'Etiquetas'
  },
  'dashboard': {
    'activity': 'Actividad',
    'weeklySales': 'Ventas semanales',
    'sales': 'Ventas',
    'recentOrders': 'órdenes recientes',
    'sources': 'Fuentes de tráfico',
    'lastweek': 'vs la semana pasada',
    'orders': 'Pedidos',
    'customers': 'Clientes',
    'tickets': 'Tickets de soporte',
    'viewReport': 'Vista del informe'
  },
  'usermenu': {
    'profile': 'Perfil',
    'signin': 'Iniciar sesión',
    'dashboard': 'Tablero',
    'signout': 'Cerrar sesión'
  },
  'error': {
    'notfound': 'Página no encontrada',
    'other': 'Ha ocurrido un error'
  },
  'check': {
    'title': 'Establecer nueva contraseña',
    'backtosign': 'Volver a Iniciar sesión',
    'newpassword': 'Nueva contraseña',
    'button': 'Establezca una nueva contraseña e inicie sesión',
    'error': 'El enlace de acción no es válido',
    'verifylink': 'Verificando enlace ...',
    'verifyemail': 'Verificando la dirección de correo electrónico ...',
    'emailverified': '¡Correo Electrónico Verificado! Redirigiendo ...'
  },
  'forgot': {
    'title': '¿Se te olvidó tu contraseña?',
    'subtitle': 'Ingrese la dirección de correo electrónico de su cuenta y le enviaremos un enlace para restablecer su contraseña.',
    'email': 'Correo electrónico',
    'button': 'Petición para la recuperación de contraseña',
    'backtosign': 'Volver a Iniciar sesión'
  },
  'login': {
    'title': 'Bienvenido',
    'subTitle': 'Inicia sesión con tu cuenta',
    'email': 'Correo electrónico',
    'email-name': 'correo electrónico',
    'password': 'Contraseña',
    'button': 'Iniciar sesión',
    'orsign': 'O ingresa con',
    'forgot': '¿Se te olvidó tu contraseña?',
    'noaccount': '¿No tienes una cuenta?',
    'create': 'Crea uno aquí',
    'error': 'La combinación de correo electrónico / contraseña no es válida',
    'rememberme': 'Recuérdame',
    'success': 'tu registro fue exitoso, ya puedes iniciar sesión'
  },
  'register': {
    'title': 'Crear cuenta',
    'name': 'Nombres',
    'last_name': 'Apellidos',
    'email': 'Correo electrónico',
    'password': 'Contraseña',
    'button': 'Crear cuenta',
    'orsign': 'O regístrate con',
    'agree': 'Al registrarse, acepta las',
    'account': '¿Ya tienes una cuenta?',
    'signin': 'Iniciar sesión'
  },
  'utility': {
    'maintenance': 'En mantenimiento'
  },
  'faq': {
    'call': '¿Tiene otras preguntas? Por favor comuníquese'
  },
  'ecommerce': {
    'products': 'Productos',
    'filters': 'Filtros',
    'collections': 'Colecciones',
    'priceRange': 'Rango de precios',
    'customerReviews': 'Opiniones de los usuarios',
    'up': 'y arriba',
    'brand': 'Marca',
    'search': 'Buscar producto',
    'results': 'Resultados ({0} de {1})',
    'orders': 'Pedidos',
    'shipping': 'Envío',
    'freeShipping': 'Envío gratis',
    'inStock': 'En stock',
    'quantity': 'Cantidad',
    'addToCart': 'Añadir al carrito',
    'buyNow': 'Compra ahora',
    'price': 'Precio',
    'about': 'Acerca de este artículo',
    'description': 'Descripción',
    'reviews': 'Reseñas',
    'details': 'Detalles de producto',
    'cart': 'Carro',
    'summary': 'Resumen del pedido',
    'total': 'Total',
    'discount': 'Descuento',
    'subtotal': 'Total parcial',
    'continue': 'Seguir comprando',
    'checkout': 'Revisa'
  },
  'tickets': {
    'ai': {
      'btnLabel': 'Asistencia IA',
      'btnReanalyze': 'Re-analizar',
      'statusIdle': 'Sin análisis IA previo',
      'statusReady': 'Análisis vigente',
      'statusLoading': 'Analizando ticket con IA...',
      'statusError': 'Error al obtener análisis',
      'contextLabel': 'Contexto adicional para la IA (opcional)',
      'panelClientTitle': 'Respuesta sugerida al cliente',
      'panelInternalTitle': 'Diagnóstico interno',
      'actionUse': 'Usar como respuesta',
      'actionRegenerate': 'Regenerar',
      'actionDismiss': 'Ignorar',
      'actionCopySteps': 'Copiar pasos',
      'actionAddNote': 'Agregar como nota',
      'errorTimeout': 'La solicitud tardó demasiado. Intenta nuevamente.',
      'errorGeneric': 'No se pudo obtener el análisis de IA.',
      'tooltipBtn': 'Obtener análisis y sugerencia de respuesta con IA',
      'tooltipReanalyze': 'Se reemplazará el análisis anterior',
    },
  },
  'menu': {
    'search': 'Buscar (presione \'ctrl + /\' para enfocar)',
    'dashboard': 'Tablero',
    'logout': 'Cerrar sesión',
    'profile': 'Perfil',
    'blank': 'Página en blanco',
    'pages': 'Páginas',
    'others': 'Otros',
    'email': 'Correo electrónico',
    'chat': 'Charla',
    'todo': 'Todo',
    'board': 'Tablero de tareas',
    'users': 'Usuarios',
    'usersList': 'Lista',
    'usersEdit': 'Editar',
    'ecommerce': 'Comercio electrónico',
    'ecommerceList': 'Productos',
    'ecommerceProductDetails': 'Detalles de producto',
    'ecommerceOrders': 'Pedidos',
    'ecommerceCart': 'Carro',
    'auth': 'Páginas de autenticación',
    'authLogin': 'Iniciar sesión / Iniciar sesión',
    'authRegister': 'Registrarse / Registrarse',
    'authVerify': 'Verificar correo electrónico',
    'authForgot': 'Se te olvidó tu contraseña',
    'authReset': 'Restablecer la contraseña',
    'errorPages': 'Páginas de error',
    'errorNotFound': 'No encontrado / 404',
    'errorUnexpected': 'Inesperado / 500',
    'utilityPages': 'Páginas de utilidades',
    'utilityMaintenance': 'Mantenimiento',
    'utilitySoon': 'Próximamente',
    'utilityHelp': 'Preguntas frecuentes / Ayuda',
    'levels': 'Niveles de menú',
    'disabled': 'Menú deshabilitado',
    'docs': 'Documentación',
    'feedback': 'Retroalimentación',
    'support': 'Apoyo',
    'landingPage': 'Landing Page',
    'pricingPage': 'Pie de pagina',

  },
  '$vuetify': {
    'badge': 'Insignia',
    'close': 'Cerca',
    'dataIterator': {
      'noResultsText': 'No se encontraron registros coincidentes',
      'loadingText': 'Cargando elementos ...'
    },
    'dataTable': {
      'itemsPerPageText': 'Filas por página:',
      'ariaLabel': {
        'sortDescending': 'Ordenados descendente.',
        'sortAscending': 'Ordenado ascendente.',
        'sortNone': 'Sin clasificar.',
        'activateNone': 'Activar para eliminar la clasificación.',
        'activateDescending': 'Activar para ordenar de forma descendente.',
        'activateAscending': 'Activar para ordenar de forma ascendente.'
      },
      'sortBy': 'Ordenar por'
    },
    'dataFooter': {
      'itemsPerPageText': 'Artículos por página:',
      'itemsPerPageAll': 'Todos',
      'nextPage': 'Siguiente página',
      'prevPage': 'Pagina anterior',
      'firstPage': 'Primera página',
      'lastPage': 'Última página',
      'pageText': '{0} - {1} de {2}'
    },
    'datePicker': {
      'itemsSelected': '{0} seleccionados',
      'nextMonthAriaLabel': 'Próximo mes',
      'nextYearAriaLabel': 'El próximo año',
      'prevMonthAriaLabel': 'Mes anterior',
      'prevYearAriaLabel': 'Año anterior'
    },
    'noDataText': 'Datos no disponibles',
    'carousel': {
      'prev': 'Visual anterior',
      'next': 'Siguiente visual',
      'ariaLabel': {
        'delimiter': 'Diapositiva de carrusel {0} de {1}'
      }
    },
    'calendar': {
      'moreEvents': '{0} más'
    },
    'fileInput': {
      'counter': '{0} archivos',
      'counterSize': '{0} archivos ({1} en total)'
    },
    'timePicker': {
      'am': 'AM',
      'pm': 'PM'
    },
    'pagination': {
      'ariaLabel': {
        'wrapper': 'A.M',
        'next': 'PM',
        'previous': 'Navegación de paginación',
        'page': 'Siguiente página',
        'currentPage': 'Pagina anterior'
      }
    }
  }
}
